import { type SanityFrameBuilderModule } from './data/sanity/queries/types'
import { FrameBuilderSelectionProvider } from './contexts/selection-context'
import { FrameBuilderSettingsContextProvider } from './contexts/settings-context'
import { FrameBuilderStateProvider } from './contexts/state-context'
import { FrameBuilderStringsProvider } from './contexts/strings-context'
import { FrameBuilderValidationProvider } from './contexts/validation-context'

import FrameBuilder from './components'

type FrameBuilderModuleProps = Pick<
  SanityFrameBuilderModule,
  | 'frameBuilderType'
  | 'updateHash'
  | 'showProgressBar'
  | 'openDimensionDetails'
  | 'defaultPassepartoutColor'
  | 'defaultPassepartoutWidth'
  | 'defaultPassepartoutHeight'
  | 'configuration'
>

const FrameBuilderModule = ({
  frameBuilderType,
  updateHash,
  showProgressBar,
  openDimensionDetails,
  defaultPassepartoutColor,
  defaultPassepartoutWidth,
  defaultPassepartoutHeight,
  configuration,
}: FrameBuilderModuleProps) => {
  return (
    <FrameBuilderStringsProvider strings={configuration.strings}>
      <FrameBuilderSettingsContextProvider
        frameBuilderType={frameBuilderType}
        configuration={configuration}
      >
        <FrameBuilderStateProvider
          defaultFrame={configuration.defaultFrame}
          defaultPassepartoutColor={defaultPassepartoutColor}
          defaultPassepartoutWidth={defaultPassepartoutWidth}
          defaultPassepartoutHeight={defaultPassepartoutHeight}
          updateHash={!!updateHash}
        >
          <FrameBuilderSelectionProvider>
            <FrameBuilderValidationProvider>
              <FrameBuilder
                showProgressBar={!!showProgressBar}
                openDimensionDetails={!!openDimensionDetails}
              />
            </FrameBuilderValidationProvider>
          </FrameBuilderSelectionProvider>
        </FrameBuilderStateProvider>
      </FrameBuilderSettingsContextProvider>
    </FrameBuilderStringsProvider>
  )
}

export default FrameBuilderModule
